import { Col, InputGroup, Row } from 'react-bootstrap';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import usePublishMessageList from './hook/usePublishMessageList';
import './publishMessage.scss';
import ButtonWithMenu from '../../common/ButtonWithMenu';
import PublishedMessageList from './component/PublishedMessageList';
import PublishMessageDetail from './component/PublishMessageDetail';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from '../../common/CustomPagination';
import MessageListSkeleton from './skeleton/MessageListSkeleton';
import MessageDetailSelecton from './skeleton/MessageDetailSkeleton';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

const PublishMessage = ({ selectedTab }) => {
  const {
    SortOptionsList,
    sortByData,
    setSortByData,
    handleChangePublishMessage,
    PUBLISH_NEW_MESSAGE_USER_OPTIONS,
    searchText,
    ListUser,
    selectedIndex,
    showingRecordsMessage,
    currentPage,
    setCurrentPage,
    pageSize,
    totalRecords,
    pageSizeHandler,
    displayPaginationMininumCount = 10,
    filteredData,
    isListApiServerError,
    listApiDataNotFoundError,
    listLoading,
    Sender_Email,
    onSearch,
    getSanitizedContent,
  } = usePublishMessageList(selectedTab);
  const PaginationTab = () => (
    <>
      {totalRecords > displayPaginationMininumCount ? (
        <CustomPagination
          pageSize={pageSize | 0}
          currentPage={currentPage | 0}
          totalCount={totalRecords | 0}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
        />
      ) : null}
    </>
  );

  return (
    <div className="publish-message-list-detail-and-filter-container">
      <div className="published-message-filter-container documents-filter-containerr filter-bar-border-top filter-bar-border-bottom mt-3 mb-md-4 mb-xs-3">
        <div className="search-container-filter pl-0">
          <Row className="justify-content-between">
            <Col
              sm={2}
              className=" border-right-documents py-3 d-flex align-items-center justify-content-center"
            >
              <span className="sort-by-label">Sort By: </span>
              <div>
                <AutoSuggestionSelectComponent
                  options={SortOptionsList}
                  components={{ IndicatorSeparator: () => null }}
                  value={sortByData}
                  onChange={(e) => {
                    setSortByData(e);
                    setCurrentPage(1);
                  }}
                  isSearchable={false}
                  inputClassName="height-32"
                  aria-labelledby="forsortby"
                />
              </div>
            </Col>
            <Col sm={4} className="py-3">
              <label htmlFor="filterByTitleReference" className="sr-only">
                By Title or Description
              </label>
              <TextInput
                parentClassName="document-search my-messaging-text-filter-contaier"
                append={
                  <InputGroup.Text>
                    <SearchSVG.SearchSVG className="primary-text-color" />
                  </InputGroup.Text>
                }
                inputProps={{
                  type: 'text',
                  placeholder: 'By Title or Description',
                  className: 'border-0 height-32',
                  value: searchText,
                  onChange: (e) => {
                    onSearch(e);
                  },
                  id: 'filterByTitleReference',
                }}
              />
            </Col>

            <Col className="publish-message-button my-auto position-relative">
              <ButtonWithMenu
                options={PUBLISH_NEW_MESSAGE_USER_OPTIONS}
                title="PUBLISH NEW MESSAGE"
                itemAction={(item) => handleChangePublishMessage(item)}
              />
            </Col>
          </Row>
        </div>
      </div>
      <div className="container-offset">
        {listLoading ? (
          <div className="message-list-detail-container">
            <div className="published-message-list-admin">
              <MessageListSkeleton />
            </div>
            <div className="flex-1">
              <MessageDetailSelecton />
            </div>
          </div>
        ) : isListApiServerError || listApiDataNotFoundError ? (
          <CustomClientError
            ErrorHeading={
              listApiDataNotFoundError
                ? 'No result found!'
                : 'Something went wrong with request!'
            }
            ErrorMessage={
              listApiDataNotFoundError
                ? 'No result found with the selected filters, Please try again'
                : 'Please try again.'
            }
          />
        ) : (
          <div>
            {totalRecords > displayPaginationMininumCount ? (
              <div className="published-message-pagination-container">
                <CustomPaginationItemsDisplay
                  pageSize={pageSize}
                  setPageSize={pageSizeHandler}
                  prefixMessage="Records per page"
                  suffixMessage={showingRecordsMessage()}
                />
                <PaginationTab />
              </div>
            ) : null}
            <div className="message-list-detail-container">
              <PublishedMessageList
                data={filteredData}
                ListUser={ListUser}
                selectedIndex={selectedIndex}
                selectedTab={selectedTab}
              />
              <PublishMessageDetail
                getSanitizedContent={getSanitizedContent}
                selectedData={filteredData[selectedIndex]}
                Sender_Email={Sender_Email}
              />
            </div>
            {totalRecords > displayPaginationMininumCount ? (
              <div className="published-message-pagination-container">
                <CustomPaginationItemsDisplay
                  pageSize={pageSize}
                  setPageSize={pageSizeHandler}
                  prefixMessage="Records per page"
                  suffixMessage={showingRecordsMessage()}
                />
                <PaginationTab />
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default PublishMessage;
